import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import {
  Monitor,
  Cpu,
  Keyboard,
  Laptop,
  Smartphone,
  Tablet,
  Tv,
  Headphones,
  Watch,
  Camera,
  Gamepad2,
  Speaker,
  Printer,
  HardDrive,
  Mouse,
} from "lucide-react";
import { useCategories } from "../../hooks/useCategories";
import { useDepartaments } from "../../hooks/useDepartaments";
import { Link } from "react-router-dom";

const categoryIcons = {
  Eletronicos: <Monitor className="h-6 w-6 text-green-400 " />,
  Componentes: <Cpu className="h-6 w-6 text-green-400  " />,
  Periféricos: <Keyboard className="h-6 w-6 text-green-400 " />,
  Notebooks: <Laptop className="h-6 w-6 text-green-400 " />,
  Celulares: <Smartphone className="h-6 w-6 text-green-400 " />,
  Tablets: <Tablet className="h-6 w-6 text-green-400 " />,
  TVs: <Tv className="h-6 w-6 text-green-400 " />,
  Áudio: <Headphones className="h-6 w-6 text-green-400 " />,
  Smartwatches: <Watch className="h-6 w-6 text-green-400 " />,
  Câmeras: <Camera className="h-6 w-6 text-green-400 " />,
  Games: <Gamepad2 className="h-6 w-6 text-green-400 " />,
  Som: <Speaker className="h-6 w-6 text-green-400 " />,
  Impressoras: <Printer className="h-6 w-6 text-green-400 " />,
  Armazenamento: <HardDrive className="h-6 w-6 text-green-400 " />,
  Mouses: <Mouse className="h-6 w-6 text-green-400 " />,
};

const DepartmentsMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const {
    data: categories,
    isLoading: isLoadingCategories,
    error: categoriesError,
  } = useCategories();
  const {
    data: departments,
    isLoading: isLoadingDepartments,
    error: departmentsError,
  } = useDepartaments();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Agrupa departamentos por category_id
  const departmentsByCategory = departments?.reduce((acc, department) => {
    if (!acc[department.category_id]) {
      acc[department.category_id] = [];
    }
    acc[department.category_id].push(department);
    return acc;
  }, {});

  const isLoading = isLoadingCategories || isLoadingDepartments;
  const error = categoriesError || departmentsError;

  // Função para criar a URL segura
  const createSafeUrl = (url) => {
    if (!url) return "";
    return url.replace(/\//g, "");
  };

  if (isLoading) {
    return (
      <div className="relative" ref={menuRef}>
        <button className="flex items-center font-medium bg-transparent border-none tracking-wide text-white py-2 px-3">
          <span className="font-bold">DEPARTAMENTOS</span>
          <ChevronDown className="ml-1 h-4 w-4" />
        </button>
      </div>
    );
  }

  if (error) {
    return (
      <div className="relative" ref={menuRef}>
        <button className="flex items-center font-medium bg-transparent border-none tracking-wide text-white py-2 px-3">
          <span className="font-bold">DEPARTAMENTOS</span>
          <ChevronDown className="ml-1 h-4 w-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center font-medium bg-transparent border-none tracking-wide text-white py-2 px-3 hover:text-green-400 transition-colors duration-200"
      >
        <span className="font-bold">DEPARTAMENTOS</span>
        <ChevronDown
          className={`ml-1 h-4 w-4 transition-transform duration-200 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {isOpen && categories && departmentsByCategory && (
        <div className="absolute left-0 top-full mt-1 w-screen max-w-4xl bg-white shadow-lg rounded-b-md transition-all duration-300 z-50 overflow-hidden border border-zinc-200">
          <div className="grid grid-cols-3 gap-4 p-4">
            {categories.map((category) => {
              const categoryDepartments =
                departmentsByCategory[category.id] || [];

              return (
                <div key={category.id} className="mb-4">
                  <h3 className="text-gray-900 font-semibold text-sm mb-2">
                    <Link
                      to={`/categoria/${createSafeUrl(category.url)}`}
                      className="transition-colors duration-200 flex items-center hover:text-green-600"
                    >
                      <span className="inline-flex mr-2">
                        {categoryIcons[category.name] || (
                          <Monitor className="h-4 w-4" />
                        )}
                      </span>
                      <span className="ml-2">{category.name}</span>
                    </Link>
                  </h3>
                  {categoryDepartments.length > 0 && (
                    <ul className="mt-1 flex flex-col gap-1">
                      {categoryDepartments.map((department) => (
                        <li key={department.id}>
                          {department?.name && (
                            <Link
                              to={`/departamento/${department.name}`}
                              className="text-sm text-gray-600 transition-colors duration-200 hover:text-black"
                            >
                              {department.name}
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              );
            })}
          </div>

          {/*<div className="bg-gray-100 p-4">
            <Link
              to="/promocoes"
              className="flex justify-between items-center no-underline"
            >
              <span className="font-medium text-black transition-colors duration-200 hover:text-green-600">
                Ver todas as promoções
              </span>
              <span className="bg-green-600 text-white text-xs px-2 py-1 rounded">
                OFERTA
              </span>
            </Link>
          </div>*/}
        </div>
      )}
    </div>
  );
};

export default DepartmentsMenu;
